import { objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { FormItem, FormLabel, FormInputPassword } from '@tesla/design-system-react';
import { useField } from 'informed';
import { FeedBack } from './Feedback.js';

var _excluded = ["label", "feedback", "helper", "caption", "tooltip", "type"],
  _excluded2 = ["id", "disabled", "readonly"];
var Password = /*#__PURE__*/React.memo(function (props) {
  var _useField = useField(_objectSpread2({}, props)),
    fieldState = _useField.fieldState,
    fieldApi = _useField.fieldApi,
    render = _useField.render,
    userProps = _useField.userProps,
    ref = _useField.ref;
  var label = userProps.label,
    feedback = userProps.feedback,
    helper = userProps.helper,
    caption = userProps.caption,
    tooltip = userProps.tooltip;
    userProps.type;
    var inputProps = _objectWithoutProperties(userProps, _excluded);
  var id = inputProps.id,
    disabled = inputProps.disabled,
    readonly = inputProps.readonly,
    restInputProps = _objectWithoutProperties(inputProps, _excluded2);
  var showError = fieldState.showError,
    error = fieldState.error,
    maskedValue = fieldState.maskedValue;
  var setValue = fieldApi.setValue,
    setTouched = fieldApi.setTouched,
    setFocused = fieldApi.setFocused;
  return render( /*#__PURE__*/React.createElement(FormItem, {
    error: showError,
    variant: "text",
    disabled: disabled,
    readOnly: readonly
  }, label ? /*#__PURE__*/React.createElement(FormLabel, {
    htmlFor: id,
    caption: caption,
    tooltip: tooltip
  }, label) : null, /*#__PURE__*/React.createElement(FormInputPassword, _extends({}, restInputProps, {
    id: id,
    disabled: disabled,
    value: !maskedValue && maskedValue !== 0 ? '' : maskedValue,
    onChange: function onChange(e) {
      setValue(e.target.value, e);
    },
    onBlur: function onBlur(e) {
      setTouched(true, e);
    },
    onFocus: function onFocus(e) {
      setFocused(true, e);
    },
    readOnly: readonly,
    inputRef: ref,
    "aria-invalid": showError,
    "aria-describedby": "".concat(id, "-feedback")
  })), /*#__PURE__*/React.createElement(FeedBack, {
    feedback: feedback,
    helper: helper,
    error: error,
    showError: showError,
    id: "".concat(id, "-feedback")
  })));
});

export { Password };
